import React from "react";
import { Field } from "formik";
import { isFunction, isArray, omit } from "lodash";

const validateField = value => {
  let error;
  if (!value) {
    error = "This field is required";
  }
  return error;
};

class Select extends React.PureComponent {
  render() {
    const {
      name,
      validate,
      title,
      errors,
      submitCount,
      touched,
      options
    } = this.props;

    let className =
      (errors && errors[name] && (touched[name] || !!submitCount)
        ? "error is-invalid"
        : "") + " text-input form-control";
    let select_options = [];

    if (isArray(options)) {
      options.map(option =>
        select_options.push(
          <option key={option.key} value={option.key}>
            {option.label}
          </option>
        )
      );
    } else {
      for (let key in options) {
        let single_group = options[key];
        select_options.push(
          <optgroup key={key} label={key}>
            {single_group.map(option => (
              <option key={option.key} value={option.key}>
                {option.label}
              </option>
            ))}
          </optgroup>
        );
      }
    }

    let selectProps = omit(this.props, ["options", "touched", "errors"]);

    return (
      <React.Fragment>
        {title &&  <label>{title}</label>}
        <div className="input-group mb-3">
          <Field
            {...selectProps}
            name={name}
            className={className}
            validate={
              validate && (isFunction(validate) ? validate : validateField)
            }
            component="select"
          >
            {select_options}
          </Field>
          {errors && errors[name] && touched[name] && (
            <div className="invalid-feedback">{errors[name]}</div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default Select;
